module.exports = __webpack_public_path__ + "zarustajici-nehty_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/obecna-a-zilni-chirurgie/zarustajici-nehty_2_before.jpg
// module id = 1040
// module chunks = 0